import React, { useState, useEffect } from 'react';
import Layout from '../componentes/Plantilla/Plantilla';
import Breadcrumbs from '../componentes/UI/Breadcrumbs';
import { useScrollAnimation } from '../ganchos/usarAnimacionScroll';
import styles from './Proyectos.module.css';
import logoSeima from '../recursos/imagenes/logo.webp';

// We'll load the data generated by our script
import proyectosData from '../datos/proyectos.json';

const Proyectos = () => {
  const [refHero, heroVisible] = useScrollAnimation();
  const [refGrid, gridVisible] = useScrollAnimation();
  
  const [filtroActivo, setFiltroActivo] = useState('todos');
  const [imagenActiva, setImagenActiva] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Extraer categorías únicas
  const categoriasUnicas = ['todos', ...new Set(proyectosData.map(p => p.category))];

  // Nombres bonitos para las categorías
  const nombresCategorias = {
    'todos': 'Todos los Proyectos',
    'aspiradoras': 'Aspiradoras',
    'hidrolavadoras': 'Hidrolavadoras',
    'lavanderia': 'Lavandería Industrial',
    'secadoras': 'Secadoras',
    'planchadoras': 'Planchadoras',
    'limpieza-pisos': 'Limpieza de Pisos',
    'colectores': 'Colectores de Polvo',
    'otros': 'Otros Equipos'
  };

  const proyectosFiltrados = filtroActivo === 'todos' 
    ? proyectosData 
    : proyectosData.filter(p => p.category === filtroActivo);

  return (
    <Layout>
      <div className={styles.pageWrapper}>
        {/* Hero Section */}
        <section 
          ref={refHero} 
          className={`${styles.hero} fade-in-up ${heroVisible ? 'visible' : ''}`}
        >
          <div className={styles.heroInner}>
            <Breadcrumbs paths={[{ label: 'Inicio', to: '/' }, { label: 'Proyectos' }]} />
            <div className={styles.tituloBloque}>
              <img src={logoSeima} alt="SEIMA" className={styles.logoHero} />
              <h1 className={styles.tituloHero}>
                Nuestros <span className={styles.acento}>Proyectos</span>
              </h1>
            </div>
            <div className={styles.lineaHero} />
            <p className={styles.subHero}>
              Conoce el alcance y la calidad de nuestras instalaciones a nivel industrial y comercial. Cada imagen representa nuestro compromiso con la eficiencia operativa y la satisfacción total del cliente.
            </p>
          </div>
        </section>

        {/* Galería Section */}
        <section 
          ref={refGrid} 
          className={`${styles.proyectosSection} fade-in-up ${gridVisible ? 'visible' : ''}`}
        >
          <div className="container">
            {/* Filtros */}
            <div className={styles.filtrosContenedor}>
              {categoriasUnicas.map(cat => (
                <button
                  key={cat}
                  className={`${styles.filtroBtn} ${filtroActivo === cat ? styles.activo : ''}`}
                  onClick={() => setFiltroActivo(cat)}
                >
                  {nombresCategorias[cat] || cat}
                </button>
              ))}
            </div>

            {/* Collage (Masonry Grid) */}
            {proyectosFiltrados.length > 0 ? (
              <div className={styles.masonryGrid}>
                {proyectosFiltrados.map((proyecto) => (
                  <div 
                    key={proyecto.id} 
                    className={styles.masonryItem}
                    onClick={() => setImagenActiva(proyecto)}
                  >
                    <img 
                      src={proyecto.image} 
                      alt={proyecto.title} 
                      loading="lazy"
                      className={styles.masonryImg}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                    <div className={styles.itemOverlay}>
                      <h3 className={styles.itemTitle}>{proyecto.title.replace(/-/g, ' ')}</h3>
                      <span className={styles.itemCategory}>
                        {nombresCategorias[proyecto.category] || proyecto.category}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.emptyState}>
                <p>No se encontraron proyectos en esta categoría.</p>
              </div>
            )}
          </div>
        </section>

        {/* Lightbox Modal */}
        {imagenActiva && (
          <div className={styles.lightbox} onClick={() => setImagenActiva(null)}>
            <div className={styles.lightboxImgContainer} onClick={(e) => e.stopPropagation()}>
              <button 
                className={styles.closeBtn} 
                onClick={() => setImagenActiva(null)}
                aria-label="Cerrar imagen"
              >
                &times;
              </button>
              <img 
                src={imagenActiva.image} 
                alt={imagenActiva.title} 
                className={styles.lightboxImg} 
              />
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Proyectos;
